/**
 * The constant value Infinity derived mathematically by 1 / 0.
 *
 * @type number
 */
const constantInfinity = 1 / 0;

export default constantInfinity;
